module.exports = __webpack_public_path__ + "img/374.a6b2b2ea.png";